import React from 'react';

const ProjectEntry = ({ image, title, description, links }) => {
  return (
    <div className="project-entry">
      <div className="project-image">
        <img src={image} alt={title} />
      </div>
      <div className="project-content">
        <h3 className="project-title">{title}</h3>
        <div className="project-description">{description}</div>
        <ul className="project-links">
          {links.map((link, index) => (
            <li key={index}>
              {link.url ? (
                <a href={link.url} target="_blank" rel="noopener noreferrer">
                  {link.text}
                </a>
              ) : (
                <span className="disabled-link">{link.text}</span>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ProjectEntry;
